export default __webpack_public_path__ + "static/media/wwr-img.c712a26f.webp";